// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Partials
import { PartialsModule } from '../../../partials/partials.module';
// Pages
import { CoreModule } from '../../../../core/core.module';

import { MaterialModule } from '../../../pages/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { TextInputComponent } from './text-input.component';
import { NgxMaskModule } from 'ngx-mask';
// import { NgxMaskModule } from 'ngx-mask';

@NgModule({
	declarations: [
		TextInputComponent
	],
	exports: [
		MaterialModule,
		PartialsModule,
		TextInputComponent
	],
	imports: [
        PartialsModule,
        CoreModule,
        CommonModule,
        MaterialModule,
        TranslateModule.forChild(),
		NgxMaskModule.forChild()
	],
	providers: []
})
export class TextInputModule {
}